/* eslint-disable no-template-curly-in-string */
export const gaScreenNameMapping = {
  '(iam-fe)': [
    /** Registration */
    {
      screenPathRegex: '/signup$',
      screenName: '${language}/${device}/Registration/SelectOnboardingType',
    },
    {
      screenPathRegex: '/signup/policy-type-selection$',
      screenName: '${language}/${device}/Registration/SelectPolicyType',
    },
    {
      screenPathRegex: '/signup/policy-type-selection#ProceedInfo$',
      screenName:
        '${language}/${device}/Registration/SelectPolicyType#ProceedInfo',
    },
    {
      screenPathRegex: '/signup/policy-type-selection#PNCInfo$',
      screenName: '${language}/${device}/Registration/SelectPolicyType#PNCInfo',
    },
    {
      screenPathRegex: '/signup/policy-type-selection#LifeProceedInfo$',
      screenName:
        '${language}/${device}/Registration/SelectPolicyType#LifeProceedInfo',
    },
    {
      screenPathRegex: '/signup/policy-type-selection#EBProceedInfo$',
      screenName:
        '${language}/${device}/Registration/SelectPolicyType#EBProceedInfo',
    },
    {
      screenPathRegex: '/signup/policy-type-selection#PNCProceedInfo$',
      screenName:
        '${language}/${device}/Registration/SelectPolicyType#PNCProceedInfo',
    },
    {
      screenPathRegex: '/signup/policy-info-input$',
      screenName: '${language}/${device}/Registration/InputPolicyInfo',
    },
    {
      screenPathRegex: '/signup/policy-info-input#EBMedCardInfo$',
      screenName:
        '${language}/${device}/Registration/InputPolicyInfo#EBMedCardInfo',
    },
    {
      screenPathRegex: '/signup/policy-info-input#EBAXAInfo$',
      screenName:
        '${language}/${device}/Registration/InputPolicyInfo#EBAXAInfo',
    },
    {
      screenPathRegex: '/signup/policy-info-input#PNCInfo$',
      screenName: '${language}/${device}/Registration/InputPolicyInfo#PNCInfo',
    },
    {
      screenPathRegex: '/signup/review-information$',
      screenName: '${language}/${device}/Registration/ReviewInformation',
    },
    {
      screenPathRegex: '/signup/select-username$',
      screenName: '${language}/${device}/Registration/SelectUsername',
    },
    {
      screenPathRegex: '/signup/input-username$',
      screenName: '${language}/${device}/Registration/InputUsername',
    },
    {
      screenPathRegex: '/signup/input-otp$',
      screenName: '${language}/${device}/Registration/InputOTP',
    },
    {
      screenPathRegex: '/signup/input-otp#OtpHelp$',
      screenName: '${language}/${device}/Registration/InputOTP#OtpHelp',
    },
    {
      screenPathRegex: '/signup/input-otp#OtpError$',
      screenName: '${language}/${device}/Registration/InputOTP#OtpError',
    },
    {
      screenPathRegex: '/signup/set-password$',
      screenName: '${language}/${device}/Registration/SetPassword',
    },
    {
      screenPathRegex: '/signup/success$',
      screenName: '${language}/${device}/Registration/Success',
    },
    /** 2024rls2 Onboarding Revamp - Forget Password */
    {
      screenPathRegex: '/forget-password/landing/email',
      screenName: '${language}/${device}/ForgotPassword/Landing/Email',
    },
    {
      screenPathRegex: '/forget-password/landing/mobile',
      screenName: '${language}/${device}/ForgotPassword/Landing/Mobile',
    },
    {
      screenPathRegex: '/forget-password/otp',
      screenName: '${language}/${device}/ForgotPassword/Otp',
    },
    {
      screenPathRegex: '/forget-password/otp#OtpHelp$',
      screenName: '${language}/${device}/ForgotPassword/Otp#OtpHelp',
    },
    {
      screenPathRegex: '/forget-password/otp#OtpError$',
      screenName: '${language}/${device}/ForgotPassword/Otp#OtpError',
    },
    {
      screenPathRegex: '/forget-password/reset',
      screenName: '${language}/${device}/ForgotPassword/Reset',
    },
    /** 2024rls2 Onboarding Revamp - Forget Username */
    {
      screenPathRegex: '/forget-username/select-policy$',
      screenName: '${language}/${device}/ForgotUsername/SelectPolicyType',
    },
    {
      screenPathRegex: '/forget-username/select-policy#PNCInfo$',
      screenName: '${language}/${device}/ForgotUsername/SelectPolicyType#PNCInfo',
    },
    {
      screenPathRegex: '/forget-username/input-info$',
      screenName: '${language}/${device}/ForgotUsername/InputPolicyInfo',
    },
    {
      screenPathRegex: '/forget-username/input-info#PNCInfo$',
      screenName: '${language}/${device}/ForgotUsername/InputPolicyInfo#PNCInfo',
    },
    {
      screenPathRegex: '/forget-username/input-info#EBAXAInfo$',
      screenName: '${language}/${device}/ForgotUsername/InputPolicyInfo#EBAXAInfo',
    },
    {
      screenPathRegex: '/forget-username/input-info#EBMedCardInfo$',
      screenName: '${language}/${device}/ForgotUsername/InputPolicyInfo#EBMedCardInfo',
    },
    {
      screenPathRegex: '/forget-username/review-info$',
      screenName: '${language}/${device}/ForgotUsername/ReviewPolicyInfo',
    },
    {
      screenPathRegex: '/forget-username/policy-found$',
      screenName: '${language}/${device}/ForgotUsername/PolicyFound',
    },
    {
      screenPathRegex: '/forget-username/use-other-username/life$',
      screenName: '${language}/${device}/ForgotUsername/SelectUsername',
    },
    {
      screenPathRegex: '/forget-username/use-other-username/non-life$',
      screenName: '${language}/${device}/ForgotUsername/InputUsername',
    },
    {
      screenPathRegex: '/forget-username/otp$',
      screenName: '${language}/${device}/ForgotUsername/InputOTP',
    },
    {
      screenPathRegex: '/forget-username/otp#OtpHelp$',
      screenName: '${language}/${device}/ForgotUsername/InputOTP#OtpHelp',
    },
    {
      screenPathRegex: '/forget-username/otp#OtpError$',
      screenName: '${language}/${device}/ForgotUsername/InputOTP#OtpError',
    },
    {
      screenPathRegex: '/forget-username/reset-password$',
      screenName: '${language}/${device}/ForgotUsername/ResetPassword',
    },

    /** PnC Find My Policy */
    {
      'screenPathRegex': '/find-my-policy$',
      'screenName': '2022r1.0/${language}/${device}/NS-FindMyPolicy/PolicyType',
    },
    {
      'screenPathRegex': '/find-my-policy/property-and-casualty$',
      'screenName': '2022r1.0/${language}/${device}/NS-FindMyPolicy/ChooseIDType-PnC',
    },
    {
      'screenPathRegex': '/find-my-policy/property-and-casualty/hkid-selected$',
      'screenName': '2022r1.0/${language}/${device}/NS-FindMyPolicy/HKID-PnC',
    },
    {
      'screenPathRegex': '/find-my-policy/property-and-casualty/passport-selected',
      'screenName': '2022r1.0/${language}/${device}/NS-FindMyPolicy/Passport-PnC',
    },
    {
      'screenPathRegex': '/review-information$',
      'queryParams': {
        'fromPage': 'find-my-policy/property-and-casualty/hkid-selected'
      },
      'screenName': '2022r1.0/${language}/${device}/NS-FindMyPolicy/ReviewInput-PnCHKID',
    },
    {
      'screenPathRegex': '/review-information$',
      'queryParams': {
        'fromPage': 'find-my-policy/property-and-casualty/passport-selected'
      },
      'screenName': '2022r1.0/${language}/${device}/NS-FindMyPolicy/ReviewInput-PnCPassport',
    },
    {
      'screenPathRegex': '/find-my-policy/policy-verify$',
      'screenName': '2022r1.0/${language}/${device}/NS-FindMyPolicy/Success',
    },
    {
      'screenPathRegex': '/find-my-policy/policy-not-match$',
      'screenName': '2022r1.0/${language}/${device}/NS-FindMyPolicy/PolicyFound',
    },
    {
      'screenPathRegex': '/policyfound-fail$',
      'screenName': '${queryStr.errorCode}',
    },
  ],
};
